import { RefCallBack } from 'react-hook-form';
import { TextField, TextFieldProps, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import FormInputErrorMessage from './form-input-error-message';

type Props = Omit<TextFieldProps, 'variant'> & {
  label?: string;
  errorMessage?: string;
  ref?: RefCallBack;
};

const useStyles = makeStyles(() => ({
  input: {
    width: '100%',
    maxWidth: '100%',
    marginTop: '10px',
  },
}));

const FormTextField = ({ label, errorMessage, ref: _, ...other }: Props) => {
  const classes = useStyles();
  return (
    <div className={classes.input}>
      {label && <Typography variant="caption">{label}</Typography>}
      <TextField
        error={!!errorMessage}
        inputProps={{
          style: {
            height: '30px',
            paddingRight: '40px',
            padding: '1vh 2vh',
          },
        }}
        fullWidth
        variant="outlined"
        {...other}
      />
      {errorMessage && <FormInputErrorMessage error={errorMessage} />}
    </div>
  );
};

export default FormTextField;
